import React from "react";

import { View, Modal, Linking, StyleSheet, SafeAreaView } from "react-native";
import Text from "components/Text";
import Button from "components/Button";
import Img from "components/img";

import { colors } from "assets/constants";
import { logo } from "assets/images";

interface PermissionBlockedAlertT {
  visible: boolean;
  hide: () => void;
  text: string;
}

export default function PermissionBlockedAlert(props: PermissionBlockedAlertT) {
  const { text, hide, visible } = props;

  const _goToSettings = () => {
    hide();
    Linking.openSettings();
  };

  return (
    <Modal transparent animationType="fade" visible={visible}>
      <SafeAreaView style={styles.blockedAlertContainer}>
        <View style={styles.blockedAlertBox}>
          <Img
            resizeMode={"cover"}
            source={logo.splashLogo}
            style={styles.logo}
          />
          <View style={styles.blockedAlertBoxContent}>
            <Text style={{ lineHeight: 21 }}> {text}</Text>
            <View style={styles.buttonsContainer}>
              <Button
                height={40}
                width={"47%"}
                title={{ value: "تنظیمات", size: "sm" }}
                onPress={_goToSettings}
                icon={{ name: "settings" }}
              />
              <Button
                height={40}
                width={"47%"}
                title={{ value: "متوجه شدم!", size: "sm" }}
                onPress={hide}
                outline
              />
            </View>
          </View>
        </View>
      </SafeAreaView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  blockedAlertContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.darkGlass,
  },

  blockedAlertBox: {
    width: 280,
    paddingVertical: 20,
    backgroundColor: colors.white,
    borderRadius: 20,
    elevation: 15,
  },

  blockedAlertBoxContent: {
    width: 250,
    alignSelf: "center",
    padding: 5,
  },

  logo: {
    width: 250,
    height: 90,
    alignSelf: "center",
    borderWidth: 1,
    borderColor: colors.border,
    borderRadius: 20,
  },

  buttonsContainer: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    marginTop: 20,
  },
});
